import { ChangeDetectorRef, DestroyRef, ElementRef, EventEmitter, inject, DOCUMENT } from '@angular/core';
import { LocalFacade } from '@common/localstate/frontend-shared';
import { Store } from '@ngxs/store';
import { loadVime } from './vime-loader';
import { BehaviorSubject, fromEvent, throwError, zip } from 'rxjs';
import { filter, map, switchMap, take, timeout } from 'rxjs/operators';
import { isE2E, takeWhileAlive } from '@core/frontend-shared';
import { CommonModule } from '@angular/common';
import { VimePlayerKeyboard } from './vime-player.keyboard';
import { VimePlayerLocalState } from './vime-player.localstate';
import { enableStretchedPlayer } from './vime-player.stretched';
import { VimePlayerProgress } from './vime-player.progress';
import { VimeUtils } from './vime-utils';
import { VideoScrubberComponent } from './vime-video-scrubber';
import * as i0 from "@angular/core";
import * as i1 from "@common/localstate/frontend-shared";
import * as i2 from "@ngxs/store";
import * as i3 from "@angular/common";
const _c0 = ["videoEl"];
const _c1 = ["player"];
const _c2 = ["video"];
const _c3 = (a0, a1, a2, a3, a4) => ({
  "player-stretch": a0,
  "player-nostretch": a1,
  "control-bar-static": a2,
  "control-bar-below": a3,
  "control-bar-invert": a4
});
function UiVideoPlayerComponent_Conditional_0_Conditional_1_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "track", 6);
  }
  if (rf & 2) {
    const subtitle_r1 = ctx.$implicit;
    i0.ɵɵproperty("src", subtitle_r1.src)("srclang", subtitle_r1.lang)("label", subtitle_r1.label)("default", subtitle_r1.isDefault ? 1 : undefined);
  }
}
function UiVideoPlayerComponent_Conditional_0_Conditional_1_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "vm-control-group");
    i0.ɵɵelement(1, "ui-video-scrubber", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("lockJumpAfter", ctx_r1.disallowSeekForward ? ctx_r1.savedProgressSeconds : false);
  }
}
function UiVideoPlayerComponent_Conditional_0_Conditional_1_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vm-settings-control");
  }
}
function UiVideoPlayerComponent_Conditional_0_Conditional_1_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "vm-fullscreen-control");
  }
}
function UiVideoPlayerComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "vm-player", 3, 0)(2, "vm-video", 4, 1);
    i0.ɵɵelement(4, "source", 5);
    i0.ɵɵrepeaterCreate(5, UiVideoPlayerComponent_Conditional_0_Conditional_1_For_6_Template, 1, 4, "track", 6, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "vm-default-ui", 7);
    i0.ɵɵelement(8, "vm-scrim", 8);
    i0.ɵɵelementStart(9, "vm-controls", 9);
    i0.ɵɵelement(10, "vm-playback-control", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "vm-captions");
    i0.ɵɵelementStart(12, "vm-controls", 11);
    i0.ɵɵconditionalCreate(13, UiVideoPlayerComponent_Conditional_0_Conditional_1_Conditional_13_Template, 2, 1, "vm-control-group");
    i0.ɵɵelement(14, "vm-playback-control")(15, "vm-caption-control")(16, "vm-volume-control")(17, "vm-time-progress")(18, "vm-control-spacer");
    i0.ɵɵconditionalCreate(19, UiVideoPlayerComponent_Conditional_0_Conditional_1_Conditional_19_Template, 1, 0, "vm-settings-control");
    i0.ɵɵconditionalCreate(20, UiVideoPlayerComponent_Conditional_0_Conditional_1_Conditional_20_Template, 1, 0, "vm-fullscreen-control");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("playsinline", true)("autoplay", ctx_r1.autoplay || undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("poster", ctx_r1.posterUrl)("disablePiP", true)("autoPiP", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r1.url);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.subtitles);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("hideWhenPaused", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("hideWhenPaused", false);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.enableScrubber ? 13 : -1);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r1.enableSettingsMenu ? 19 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.fullscreenToggle ? 20 : -1);
  }
}
function UiVideoPlayerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵconditionalCreate(1, UiVideoPlayerComponent_Conditional_0_Conditional_1_Template, 21, 11, "vm-player", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(2, _c3, ctx_r1.stretch, !ctx_r1.stretch, ctx_r1.controlBarStatic, ctx_r1.controlBarBelow, ctx_r1.controlBarInvert));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.vimeLoaded && ctx_r1.url ? 1 : -1);
  }
}
export let UiVideoPlayerComponent = /*#__PURE__*/(() => {
  class UiVideoPlayerComponent {
    // lock seeking/jumping forward: store how many seconds have been watched by the user
    get savedProgressSeconds() {
      const plugin = this.getPlugin(VimePlayerProgress);
      if (!this.vimeInitialized) return 0;
      if (!plugin) throw new Error('failed to find VimePlayerProgress Plugin');
      if (!plugin.ready) return 0;
      let val = plugin?.getSavedProgressSeconds();
      if (typeof val !== 'number') val = 0;
      return val;
    }
    set _poster(url) {
      this.posterUrl = url ? url : '';
    }
    set _url(url) {
      if (url === this.url) return;
      /**
       * this is required because of issue described in
       * https://github.com/vime-js/vime/issues/271
       * vime will not recognize a changed source.
       * Current workaround is to remove the whole player (via this.url = null)
       * and re-create it a few ms later. Not very efficient, but it works for now.
       */
      if (!this.loaded) {
        this.url = url;
        this.loaded = true;
        setTimeout(() => this.setupPlayer());
      } else {
        this.url = null;
        setTimeout(() => {
          this.url = url;
          this.cd.markForCheck();
          setTimeout(() => {
            this.reset();
            this.setupPlayer();
          });
        }, 1);
      }
    }
    set _videoId(id) {
      this.videoId = id;
      this.plugins.forEach(plugin => plugin.setVideoId?.(id));
    }
    set _controlBarStatic(val) {
      this.controlBarStatic = val;
      // if no custom theme is set, set theme to static
      // if(val && !this.theme) this.theme = 'static'; 
    }
    get onPlayerProgress$() {
      return VimeUtils.waitForValidVime(this, !this.vimeLoaded ? this.vimeLoadingPromise : null).pipe(switchMap(player => {
        return fromEvent(this.nativePlayer.nativeElement, 'vmCurrentTimeChange').pipe(takeWhileAlive(this.destroyRef), map(e => e.detail));
      }));
    }
    get playing() {
      if (!this.nativePlayer) return null;
      return this.nativePlayer.nativeElement.playing;
    }
    constructor(elementRef, localState, cd, store, document) {
      this.elementRef = elementRef;
      this.localState = localState;
      this.cd = cd;
      this.store = store;
      this.document = document;
      this.destroyRef = inject(DestroyRef);
      this.loaded = false; // false until player has been initialized at least once
      this.vimeLoaded = false; // true if assets have been loaded
      this.vimeInitialized = false;
      this.playerLoaded$ = new BehaviorSubject(false); // becomes true when vime loader resolves
      this.playerInitialized$ = new BehaviorSubject(false); // re-emits after creating player for a different video URL!
      this.posterUrl = '';
      this.subtitles = [];
      this.globalShortcuts = true; // dummy prop for compatibility with vidstack component api
      this.stretch = true;
      this.controlBarStatic = false;
      this.controlBarBelow = false;
      this.controlBarInvert = false;
      this.autoplay = false;
      this.autoplayAll = false;
      this.fullscreenToggle = true;
      this.enableSettingsMenu = false;
      this.enableScrubber = true;
      this.hotkeys = true;
      this.disallowSeekForward = false;
      this.disallowSeekForwardMessage = 'Nicht erlaubt!';
      this.throttleInterval = 2000;
      this.onPlayerReady = new EventEmitter();
      this.onPlayerProgressThrottled = new EventEmitter();
      this.onPlayerEnded = new EventEmitter();
      this.plugins = [];
      this.vimeLoadingPromise = loadVime().then(() => {
        this.vimeLoaded = true;
        this.vimeLoadingPromise = null;
        this.playerLoaded$.next(true);
        this.cd.markForCheck();
      });
    }
    ngOnInit() {
      this.plugins.push(new VimePlayerKeyboard(this.document, {
        enable: this.hotkeys,
        fullscreenToggle: this.fullscreenToggle
      }), new VimePlayerProgress({
        enable: true,
        throttleInterval: this.throttleInterval
      }), new VimePlayerLocalState(this.localState, this.store, {}));
      const progressPlugin = this.getPlugin(VimePlayerProgress);
      if (progressPlugin) {
        progressPlugin.onPlayerProgressThrottled$.pipe(takeWhileAlive(this.destroyRef)).subscribe(progress => {
          this.onPlayerProgressThrottled.emit(progress);
        });
      }
    }
    isEnd2EndTest() {
      return isE2E();
    }
    // called when changing the player's source, before re-executing setupPlayer.
    reset() {
      this.plugins.forEach(p => {
        if (p.reset) p.reset();
      });
    }
    setupPlayer() {
      VimeUtils.waitForValidVime(this, !this.vimeLoaded ? this.vimeLoadingPromise : null).subscribe(player => {
        this.vimeInitialized = false;
        this.playerInitialized$.next(false);
        // NOTE: vmPlaybackReady does not always fire. 
        // it is mandatory to check if playback is ready first.
        if (player.playbackReady) {
          // console.log('playbackReady, init immediately')
          this.initializePlayer();
        } else {
          // console.log('playback not ready, wait for event')
          player.addEventListener('vmPlaybackReady', () => {
            this.initializePlayer();
          });
        }
      });
    }
    // runs after vmPlaybacKReady fired
    initializePlayer() {
      const player = this.nativePlayer.nativeElement;
      if (this.vimeInitialized || !player) return;
      this.vimeInitialized = true;
      VimeUtils.blockContextMenu(player);
      setTimeout(() => {
        if (this.stretch) enableStretchedPlayer(this.nativePlayer);
      });
      this.plugins.forEach(p => {
        p.initialize(player, this.url);
      });
      // autopause player when another player is started.
      // disabled as it is a potential source of issue
      player.autopause = false;
      player.addEventListener('vmPlaybackEnded', e => {
        this.onPlayerEnded.emit(e);
      });
      if (this.autoplay) VimeUtils.autoplay(player);
      this.cd.markForCheck();
      const readyPerPlugin = this.plugins.map(plugin => plugin.ready$.pipe(filter(v => v === true), timeout({
        each: 1000,
        with: () => throwError(() => new Error('PlayerPlugin did not emit ready in time: ' + plugin))
      })));
      zip(readyPerPlugin).pipe(take(1)).subscribe(() => {
        this.playerInitialized$.next(true);
        this.onPlayerReady.emit(player);
      });
    }
    // checks player reay state and either executes or queues passed function.
    queuePlayerCommand(cmd) {
      if (this.vimeInitialized) {
        cmd(this.nativePlayer.nativeElement);
      } else {
        this.playerInitialized$.pipe(filter(v => v), take(1)).subscribe(() => {
          cmd(this.nativePlayer.nativeElement);
        });
      }
    }
    // public player API --------------------------------------------------------
    play() {
      return this.setPlay(true);
    }
    pause() {
      return this.setPlay(false);
    }
    togglePlay() {
      if (this.playing) this.pause();else this.play();
    }
    setPlay(explicitState = null, allowRetry = false) {
      this.queuePlayerCommand(player => VimeUtils.setPlay(player, explicitState, allowRetry));
    }
    jump(direction, seconds = 10) {
      this.queuePlayerCommand(player => VimeUtils.jump(player, direction, seconds));
    }
    setCurrentTime(seconds, enforcePause = false) {
      this.queuePlayerCommand(player => {
        const wasPlayingBefore = player.playing;
        player.currentTime = seconds;
        // dirty fix: vime seems to auto-start the video when first setting the current time.
        // https://github.com/vime-js/vime/issues/198
        if (!wasPlayingBefore && enforcePause) {
          player.paused = true;
          setTimeout(() => {
            player.paused = true;
          }, 50);
        }
      });
    }
    // NOTE: Unfortunately focusing seems unreliable. 
    // In some cases, focusing works, in others, it won't.
    // this is a problem that cannot be solved by us as its an issue within vime.
    focus() {
      this.queuePlayerCommand(player => {
        const playbackControls = player.querySelectorAll('vm-playback-control');
        if (playbackControls.length) {
          // we know the playback contol has a shadow dome with a single element being a VmControl https://vimejs.com/components/ui/controls/control
          playbackControls[0].shadowRoot.children[0].focusControl();
        }
      });
    }
    setCurrentTimeInPercent(progressInPercent) {
      this.queuePlayerCommand(player => {
        if (player.duration) this.setCurrentTime(player.duration * progressInPercent);
      });
    }
    setUnlockedProgress(progressInPercent) {
      this.getPlugin(VimePlayerProgress)?.setUnlockedProgress(progressInPercent);
    }
    getPlugin(ctor) {
      return this.plugins.find(p => p instanceof ctor) || null;
    }
    ngOnDestroy() {
      this.plugins.forEach(p => {
        p.destroy();
      });
      if (this.nativePlayer?.nativeElement) {
        this.nativePlayer.nativeElement.remove();
        this.nativePlayer.nativeElement = null;
      }
    }
    static {
      this.ɵfac = function UiVideoPlayerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiVideoPlayerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.LocalFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiVideoPlayerComponent,
        selectors: [["ui-video-player"]],
        viewQuery: function UiVideoPlayerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5)(_c1, 5)(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.videoEl = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nativePlayer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.videoElement = _t.first);
          }
        },
        inputs: {
          _poster: [0, "poster", "_poster"],
          _url: [0, "url", "_url"],
          subtitles: "subtitles",
          _videoId: [0, "videoId", "_videoId"],
          globalShortcuts: "globalShortcuts",
          stretch: "stretch",
          _controlBarStatic: [0, "controlBarStatic", "_controlBarStatic"],
          controlBarBelow: "controlBarBelow",
          controlBarInvert: "controlBarInvert",
          autoplay: "autoplay",
          autoplayAll: "autoplayAll",
          fullscreenToggle: "fullscreenToggle",
          enableSettingsMenu: "enableSettingsMenu",
          enableScrubber: "enableScrubber",
          theme: "theme",
          hotkeys: "hotkeys",
          disallowSeekForward: "disallowSeekForward",
          disallowSeekForwardMessage: "disallowSeekForwardMessage",
          throttleInterval: "throttleInterval"
        },
        outputs: {
          onPlayerReady: "onPlayerReady",
          onPlayerProgressThrottled: "onPlayerProgressThrottled",
          onPlayerEnded: "onPlayerEnded"
        },
        decls: 1,
        vars: 1,
        consts: [["player", ""], ["video", ""], [3, "ngClass"], [1, "vime-element", 3, "playsinline", "autoplay"], ["cross-origin", "true", 3, "poster", "disablePiP", "autoPiP"], ["type", "video/mp4", 3, "src"], ["kind", "subtitles", 3, "src", "srclang", "label", "default"], ["no-controls", ""], ["gradient", "up"], ["pin", "center", "justify", "center", "activeDuration", "1600", 3, "hideWhenPaused"], ["hide-tooltip", "", 1, "overlay-playback-control"], ["full-width", "", "pin", "bottomRight", "activeDuration", "1600", "hideOnMouseLeave", "1", 3, "hideWhenPaused"], [3, "lockJumpAfter"]],
        template: function UiVideoPlayerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UiVideoPlayerComponent_Conditional_0_Template, 2, 8, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.isEnd2EndTest() ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i3.NgClass, VideoScrubberComponent],
        styles: ["vm-player{--vm-color-dark:#313131;--vm-color-gray-100:rgba(0, 0, 0, .1);--vm-color-gray-200:rgba(0, 0, 0, .27);--vm-color-gray-300:rgba(0, 0, 0, .38);--vm-color-gray-500:rgba(0, 0, 0, .64);--vm-color-gray-600:rgba(0, 0, 0, .7);--vm-color-white-100:rgba(255, 255, 255, .1);--vm-color-white-200:rgba(255, 255, 255, .27);--vm-color-white-700:rgba(255, 255, 255, .87);--vm-fade-transition:opacity .3s ease-in-out;--vm-media-z-index:0;--vm-blocker-z-index:1;--vm-ui-z-index:2;--vm-loading-screen-z-index:1;--vm-poster-z-index:5;--vm-scrim-z-index:10;--vm-click-to-play-z-index:20;--vm-dbl-click-fullscreen-z-index:20;--vm-captions-z-index:30;--vm-spinner-z-index:40;--vm-controls-z-index:50;--vm-tooltip-z-index:60;--vm-menu-z-index:70;--vm-skeleton-z-index:100;--vm-player-bg:#000;--vm-player-border-radius:4px;--vm-player-font-family:\"Helvetica Neue\",\"Segoe UI\",Helvetica,Arial,sans-serif;--vm-loading-screen-dot-size:12px;--vm-loading-screen-pulse-duration:1.5s;--vm-loading-screen-dot-color:var( --vm-player-theme, var(--vm-color-white-700) );--vm-skeleton-color:hsl(0, 10%, 90%);--vm-skeleton-sheen-color:hsl(0, 10%, 97%);--vm-slider-thumb-width:13px;--vm-slider-thumb-height:13px;--vm-slider-thumb-bg:#fff;--vm-slider-thumb-border:2px solid transparent;--vm-slider-track-height:3px;--vm-slider-track-focused-height:5px;--vm-slider-track-color:var(--vm-color-white-200);--vm-slider-value-color:var(--vm-player-theme, #fff);--vm-tooltip-border-radius:3px;--vm-tooltip-font-size:14px;--vm-tooltip-padding:calc(var(--vm-control-spacing) / 1.5);--vm-tooltip-fade-duration:.2s;--vm-tooltip-fade-timing-func:ease;--vm-tooltip-spacing:14px;--vm-tooltip-box-shadow:0 0 2px var(--vm-color-gray-500);--vm-tooltip-bg:var(--vm-color-dark);--vm-tooltip-color:var(--vm-color-white-700);--vm-spinner-width:80px;--vm-spinner-height:80px;--vm-spinner-thickness:3px;--vm-spinner-fill-color:#fff;--vm-spinner-track-color:var(--vm-color-white-200);--vm-spinner-spin-duration:1.1s;--vm-spinner-spin-timing-func:linear;--vm-scrim-bg:var(--vm-color-gray-300);--vm-captions-text-color:#fff;--vm-captions-font-size:18px;--vm-captions-font-size-medium:22px;--vm-captions-font-size-large:24px;--vm-captions-font-size-xlarge:28px;--vm-captions-cue-bg-color:var(--vm-color-gray-600);--vm-captions-cue-border-radius:2px;--vm-captions-cue-padding:.2em .5em;--vm-controls-bg:transparent;--vm-controls-border-radius:4px;--vm-controls-padding:var(--vm-control-spacing);--vm-controls-spacing:var(--vm-control-spacing);--vm-control-group-spacing:var(--vm-control-spacing);--vm-control-border:0;--vm-control-scale:1;--vm-control-border-radius:3px;--vm-control-spacing:8px;--vm-control-padding:4px;--vm-control-icon-size:28px;--vm-control-color:#fff;--vm-control-tap-highlight:var(--vm-color-white-200);--vm-control-focus-color:#fff;--vm-control-focus-bg:var(--vm-player-theme, var(--vm-color-white-200));--vm-scrubber-loading-stripe-size:25px;--vm-scrubber-buffered-bg:var(--vm-color-white-200);--vm-scrubber-loading-stripe-color:var(--vm-color-white-200);--vm-scrubber-tooltip-spacing:10px;--vm-time-font-size:14px;--vm-time-font-weight:400;--vm-time-color:var(--vm-color-white-700);--vm-menu-color:var(--vm-color-white-700);--vm-menu-bg:var(--vm-color-dark);--vm-menu-font-size:14px;--vm-menu-font-weight:400;--vm-menu-transition:transform .25s ease-out;--vm-menu-item-padding:8px;--vm-menu-item-focus-color:var(--vm-menu-color);--vm-menu-item-focus-bg:var(--vm-color-white-100);--vm-menu-item-tap-highlight:var(--vm-color-white-100);--vm-menu-item-hint-color:var(--vm-menu-color);--vm-menu-item-hint-font-size:13px;--vm-menu-item-hint-opacity:.54;--vm-menu-item-badge-color:var(--vm-menu-color);--vm-menu-item-badge-bg:transparent;--vm-menu-item-badge-font-size:10px;--vm-menu-item-arrow-color:var(--vm-menu-color);--vm-menu-item-check-icon-size:16px;--vm-menu-item-divider-color:var(--vm-color-white-100);--vm-settings-width:275px;--vm-settings-padding:8px;--vm-settings-max-height:75%;--vm-settings-border-radius:2px;--vm-settings-shadow:0 0 8px 2px var(--vm-color-gray-100);--vm-settings-scroll-width:10px;--vm-settings-scroll-thumb-color:var(--vm-color-white-200);--vm-settings-scroll-track-color:var(--vm-menu-bg);--vm-settings-transition:transform .2s cubic-bezier(0, 0, .4, 1) .16s,opacity .2s cubic-bezier(0, 0, .4, 1) .16s}vm-player[video]{--vm-tooltip-spacing:18px}vm-player[mobile],vm-player[touch]{--vm-control-border-radius:50%}vm-player[mobile]{--vm-settings-width:100%;--vm-menu-control-padding:12px calc(var(--vm-control-padding) * 2)}vm-player[audio]{--vm-controls-bg:var(--vm-color-dark);--vm-settings-max-height:200px;--vm-tooltip-spacing:10px}ui-video-player{display:block;width:100%}ui-video-player .player-stretch,ui-video-player .player-stretch .vime-element{height:100%;width:auto;padding-top:0!important;display:block}ui-video-player .player-stretch .vime-element::shadow .player{border:10px solid #faa}ui-video-player .debug{position:absolute;top:10px;left:50px;background:#6d1d1d;padding:10px}ui-video-player .vime-element{--vm-player-font-family: inherit}ui-video-player .vime-element .overlay-playback-control{--vm-control-scale: 3.5;background:#00000040;padding:30px;width:95px;height:100px}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UiVideoPlayerComponent;
})();